import TechnologyDetailPage from "@/pages/technologies/components/TechnologyDetailPage";

export default function AwsTechPage() {
  return <TechnologyDetailPage slug="aws" />;
}